import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Query } from "react-apollo";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ReactToPrint from "react-to-print";

// {{change 1}}
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import SplashScreen from "js/pages/SplashScreen";
import BeneficioGraphQL from "js/graphql/resolvers/beneficio.resolver";
import { _t } from "js/utils/TranslationService";
import SolicitudContent from "./SolicitudContent";
import SolicitudCupon from "./SolicitudCupon";
import "./solicitud.css";
import moment from "moment";
import logoPrograma from "../../../images/reports/imgExampleLogoPrograma.png";
import logoBeneficio from "../../../images/reports/imgExambleBenificio.jpeg";

class Solicitud extends React.PureComponent {
  constructor(props) {
    super(props);
    const isNew =
      props.history.location.pathname.indexOf("mi-solicitud-beneficio") === -1;
    this.state = {
      isNew: isNew,
      logoPrograma: null
    };
  }
  // {{change 2}}
  handleDownloadPDF = async () => {
    const exportContainer = document.getElementById("pdf-export-container");
    exportContainer.classList.add("pdf-export-mode");

    const canvas = await html2canvas(exportContainer, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff"
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a3"
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pageWidth;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    const yPosition = imgHeight < pageHeight ? (pageHeight - imgHeight) / 2 : 0;

    pdf.addImage(imgData, "JPEG", 0, yPosition, imgWidth, imgHeight);
    pdf.save(`Reporte_Solicitud_${moment().format("YYYYMMDDHHmmss")}.pdf`);

    exportContainer.classList.remove("pdf-export-mode");
  };

  // ... existing code ...
  backToCatalogo = () => {
    const { history } = this.props;
    const { isNew } = this.state;
    history.push({
      pathname: isNew ? "/catalogo-beneficios" : "/mis-solicitudes-beneficios"
    });
  };

  render() {
    const url = window.location.hostname.replace("www.", "");
    const protocol = window.location.protocol;
    const { classes, programa } = this.props;
    const programLogo = programa.template.header.logoPrincipal
      ? programa.template.header.logoPrincipal.url
      : null;
    const { isNew } = this.state;

    return (
      <Query
        query={BeneficioGraphQL.queries.getBeneficioSolicitudById}
        variables={{
          idSolicitud: parseInt(this.props.computedMatch.params.idSolicitud, 10)
        }}
        errorPolicy="all"
      >
        {({ loading, error, data }) => {
          if (loading) return <SplashScreen />;
          if (error) return `Error! ${error.message}`;

          let solicitud = data.getMisBeneficiosSolicitudes.itemsPagina[0];
          let logo = programLogo;

          solicitud.beneficio.logo = solicitud.beneficio.logo;

          if (url.includes("dev") || url.includes("qa")) {
            solicitud.beneficio.logo = logoBeneficio;
            logo = logoPrograma;
          }

          return (
            <Paper className={"solicitud-container"}>
              <Grid
                container
                spacing={24}
                className={"solicitud-inner-container"}
              >
                <Grid item xs={12}>
                  {solicitud && (
                    <React.Fragment>
                      {isNew && (
                        <Typography
                          variant="h5"
                          gutterBottom
                          className={"main-title"}
                        >
                          {`${_t(
                            "¡Felicitaciones! Estos son los detalles de tu cupón"
                          )}:`}
                        </Typography>
                      )}
                      <Grid container spacing={24} style={{ margin: "0 20" }}>
                        <Grid item xs={12} id={"element-to-print"}>
                          <SolicitudContent
                            classes={classes}
                            programLogo={logo}
                            beneficio={solicitud.beneficio}
                            idSolicitud={solicitud.idSolicitud}
                          />
                          <div
                            id="pdf-export-container"
                            className="pdf-export-mode"
                            style={{
                              position: "absolute",
                              left: "-9999px",
                              top: 0,
                              width: "1120px"
                            }}
                          >
                            <SolicitudCupon
                              classes={classes}
                              programLogo={logo}
                              beneficio={solicitud.beneficio}
                              idSolicitud={solicitud.idSolicitud}
                              ref={el => {
                                this.componentInstance = el;
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid container>
                          <Grid
                            container
                            item
                            className={classes.containerBackBtns}
                            xs={12}
                            md={6}
                          >
                            <Button
                              onClick={this.backToCatalogo}
                              variant="outlined"
                              color="primary"
                              className={classes.btn}
                            >
                              {isNew
                                ? _t("Volver al catálogo")
                                : _t("Volver a mis solicitudes")}
                            </Button>
                          </Grid>
                          <Grid
                            container
                            item
                            xs={12}
                            md={6}
                            className={classes.containerActionBtns}
                          >
                            <ReactToPrint
                              content={() => this.componentInstance}
                              trigger={() => (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.btn}
                                >
                                  {_t("Imprimir")}
                                </Button>
                              )}
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.btn}
                              onClick={this.handleDownloadPDF}
                            >
                              {_t("Descargar")}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  )}
                  {!solicitud && (
                    <Grid container spacing={24}>
                      <Typography
                        variant="h5"
                        gutterBottom
                        className={"main-title"}
                      >
                        {`${_t(
                          "No existe una solicitud de beneficio con este ID"
                        )}:`}
                      </Typography>
                      <Grid item xs={12}>
                        <Button
                          onClick={this.backToCatalogo}
                          variant="contained"
                          color="primary"
                        >
                          {_t("Volver al catálogo")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Paper>
          );
        }}
      </Query>
    );
  }
}

Solicitud.propTypes = {
  classes: PropTypes.object
};

Solicitud.defaultProps = {};

export default withRouter(Solicitud);
